module.exports = __webpack_public_path__ + "img/icon_dpi.d3baaedb.svg";